var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.auth.account && !_vm.$route.meta.public)?_c('home-navbar'):_vm._e(),_c('div',{staticClass:"page-content"},[_c('keep-alive',[_c('router-view',{key:_vm.$route.fullPath})],1),_c('CustomFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }